<template>
  <footer>
    <p>Wait for more projects soon</p>
    <lottie-player :src="lottiePlayer" background="transparent" speed="1" loop autoplay></lottie-player>
  </footer>
</template>

<script>
export default {
  name: "footer-layout",
  data() {
    return {
      lottiePlayer: require("@/assets/media/footer.json"),
    };
  },
}
</script>

<style></style>